import {
  useModalContext,
  WSButton,
  WSButtons,
  WSForm,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

export const CONFIRM_TERMINATE_CARD_MODAL = "CONFIRM_TERMINATE_CARD_MODAL";

export const ConfirmTerminateCard: React.FC = props => {
  const { closeModal } = useModalContext();

  return (
    <WSModal
      name={CONFIRM_TERMINATE_CARD_MODAL}
      size="XS"
      onClose={() => closeModal(CONFIRM_TERMINATE_CARD_MODAL)}
    >
      {({ onSubmit }) => (
        <>
          <WSText.Heading3 mb="M">
            Are you sure you want to terminate this card?
          </WSText.Heading3>
          <WSText.Paragraph>
            You can order a new one at any time.
          </WSText.Paragraph>

          <WSForm
            onSubmit={() => {
              closeModal(CONFIRM_TERMINATE_CARD_MODAL);
              onSubmit();
            }}
          >
            <WSButtons mt="M" format="modal">
              <WSForm.SubmitButton kind="Destructive">
                Terminate
              </WSForm.SubmitButton>
              <WSButton.Secondary
                onClick={() => closeModal(CONFIRM_TERMINATE_CARD_MODAL)}
              >
                Cancel
              </WSButton.Secondary>
            </WSButtons>
          </WSForm>
        </>
      )}
    </WSModal>
  );
};
